import { MenuItemProps, MenuListProps } from "@chakra-ui/react";

const MENU_BG = "#131B26";

/** Shared submenu panel + item styles for header dropdowns */
export const headerMenuListProps: MenuListProps = {
  bg: MENU_BG,
  border: "1px solid",
  borderColor: "whiteAlpha.200",
  borderRadius: "10px",
  py: 1,
  minW: "180px",
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.45)",
};

export const headerMenuItemProps: MenuItemProps = {
  bg: "transparent",
  color: "white",
  fontSize: "sm",
  fontWeight: "medium",
  py: 3,
  px: 4,
  borderRadius: "md",
  mx: 1,
  _hover: { bg: "whiteAlpha.100" },
  _focus: { bg: "whiteAlpha.100" },
};
